__turbopack_context__.v({
  "chatPanel": "header-panel-module-scss-module__XZTgkq__chatPanel",
  "chatPanel__bot": "header-panel-module-scss-module__XZTgkq__chatPanel__bot",
  "chatPanel__botImage": "header-panel-module-scss-module__XZTgkq__chatPanel__botImage",
  "chatPanel__botName": "header-panel-module-scss-module__XZTgkq__chatPanel__botName",
  "chatPanel__botNameOnline": "header-panel-module-scss-module__XZTgkq__chatPanel__botNameOnline",
  "chatPanel__buttonClose": "header-panel-module-scss-module__XZTgkq__chatPanel__buttonClose",
  "chatPanel__decsription": "header-panel-module-scss-module__XZTgkq__chatPanel__decsription",
  "chatPanel__title": "header-panel-module-scss-module__XZTgkq__chatPanel__title",
});
